import { ReactNode } from 'react'
import { withAuthenticationRequired } from 'lib/auth'

interface Props {
  children?: ReactNode
}

const AuthenticationRequired = ({ children }: Props): JSX.Element => {
  return <>{children}</>
}

export default withAuthenticationRequired(AuthenticationRequired)
